import {Component, HostListener, OnInit} from '@angular/core';
import { Synoptic } from '../../model/synoptics/synoptic';
import { Tenant } from '../../model/tenant';
import { SynopticFilters } from '../../model/filters/synoptic-filters';
import { SynopticsService } from '../../services/synoptics.service';
import { TenantsService } from '../../services/tenants.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';
import { AuthGuard } from '../../common/auth-guard.service';
import { CommonMessagesService } from '../../services/common-messages.service';
import { FiltersService } from '../../services/filters.service';
import { SortOrder } from '../../model/sort-order';

@Component({
  selector: 'app-synoptics',
  templateUrl: './synoptics.component.html',
  styleUrls: ['./synoptics.component.scss']
})
export class SynopticsComponent implements OnInit {

  public synoptics: Synoptic[];
  public totalSynoptics: number;
  public loadingSynoptics: boolean;
  public tenants: Tenant[];

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: SynopticFilters;
  public displayFailedDeleteList: boolean;
  public failedDeleteList: any[];
  public filtersFilled: boolean;

  constructor(private synopticsService: SynopticsService,
              private tenantsService: TenantsService,
              private messageService: MessageService,
              private i18n: TranslocoService,
              private confirmationService: ConfirmationService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<SynopticFilters>) {
    this.currentFilters = new SynopticFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.synoptics = new Array(this.rows);
    if (this.authGuardService.superAdminRequired()) {
      this.tenantsService.getTenants().subscribe(response => {
        this.tenants = response.tenants
          .sort((a, b) => a.name > b.name ? 1 : -1);
        Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      });
    } else {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    }
  }

  private loadSynoptics(offset?: number, limit?: number): void {
    this.loadingSynoptics = true;
    this.synoptics = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.synopticsService.getSynoptics(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters: this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.synoptics = response.synoptics;
        this.totalSynoptics = response.totalElements;
        this.loadingSynoptics = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadSynoptics(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new SynopticFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadSynoptics(this.first / this.rows, this.rows);
  }

  confirmAndDelete(synoptic: Synoptic): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteSynoptic(synoptic.uuid);
    });
  }

  deleteSynoptic(uuid: string): void {
    this.synopticsService.deleteSynoptic(uuid).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadSynoptics(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) { return; }
    const uuids = this.selected.map(item => item.uuid);

    this.synopticsService.deleteSynoptics(uuids).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadSynoptics(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  trimFieldsForm(filters: SynopticFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
